import React from "react";
import {Controller} from "react-hook-form";
import MaterialInput from "./MaterialInput";

interface CustomInputProps {
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

interface FormMaterialInputProps {
    control: any;
    name: string;
    label?: string;
    className?: string;
    id?: string;
    helperText?: string;
    type?: string;
    multiline?: boolean;
    rows?: number;
    maxRows?: number;
    inputProps?: CustomInputProps;
    disabled?: boolean;
    shrink?: boolean;
    endAdornment?: any;
}


export const FormMaterialInput = ({ className, helperText, id, label, name, control, type, multiline, rows, maxRows, inputProps, shrink, endAdornment }: FormMaterialInputProps) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState, ...rest }) => {
                const error = rest.formState.errors[name]?.message as string || '';
                return (
                    <MaterialInput
                        multiline={multiline}
                        className={className}
                        label={label}
                        id={id || name}
                        type={type || "text"}
                        error={!!error}
                        helperText={error || helperText}
                        maxRows={maxRows}
                        rows={rows}
                        shrink={shrink}
                        endAdornment={endAdornment}
                        {...field}
                        {...inputProps}
                    />
                )
            }}
        />
    );
}